import { render, staticRenderFns } from "./BadRequestModal.vue?vue&type=template&id=9148442a&scoped=true"
import script from "./BadRequestModal.js?vue&type=script&lang=js&external"
export * from "./BadRequestModal.js?vue&type=script&lang=js&external"
import style0 from "./BadRequestModal.scss?vue&type=style&index=0&id=9148442a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9148442a",
  null
  
)

export default component.exports